// extracted by mini-css-extract-plugin
module.exports = {"WbPartnersLogo--white":"wb-partners-logo_WbPartnersLogo--white__9lmbl","WbPartnersLogo--black":"wb-partners-logo_WbPartnersLogo--black__EDGls"};